import {
  LOADING_ACCURACY,
  GET_ACCURACY,
  ERROR_ACCURACY
} from "store/actions/accuracyAction";

export default (state = {}, action) => {
  switch (action.type) {
    case LOADING_ACCURACY:
      return {
        ...state,
        isLoadingAccuracy: action.payload
      };
    case ERROR_ACCURACY:
      return {
        ...state,
        errorAccuracy: action.payload
      };
    case GET_ACCURACY:
      return {
        ...state,
        getAccuracy: action.payload
      };
    default:
      return state;
  }
};
